// LiveWave.js — the recording wave on the record circle, matching the classic
// recorder's dynamic: it only MOVES when speech is heard. On speech the
// amplitude snaps to MAX and the sine advances a step; in silence the phase
// FREEZES and the amplitude decays back to a small flat baseline. So a quiet
// room shows a still, low wave — it doesn't sine through silence.
import React, { useEffect, useRef, useState } from 'react';
import { useComprehendLive } from 'agent/useComprehendLive';

const BARS = 5;
const TICK_MS = 60;
const SPEECH_RMS = 0.012; // mic level above this counts as speech

const LiveWave = ({ color = '#fff', width = 44, height = 26 }) => {
  const { state } = useComprehendLive();
  const [, force] = useState(0);
  const phaseRef = useRef(0);
  const ampRef = useRef(0);
  // Latest mic level for the interval closure (re-read each render).
  const micRef = useRef(0);
  micRef.current = state.micLevel || 0;

  useEffect(() => {
    const id = setInterval(() => {
      if (micRef.current > SPEECH_RMS) {
        ampRef.current = 1; // speech -> amplitude to MAX
        phaseRef.current += 0.5; // ...and advance the sine a step
      } else {
        ampRef.current *= 0.9; // silence -> decay, phase frozen
      }
      force((n) => n + 1);
    }, TICK_MS);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const barW = 4;
  const gap = (width - BARS * barW) / (BARS - 1);
  const amp = ampRef.current;

  return (
    <svg width={width} height={height} aria-hidden="true">
      {Array.from({ length: BARS }).map((_, i) => {
        const shape = 0.5 + 0.5 * Math.sin(phaseRef.current + i * 0.9);
        const h = Math.max(3, (0.15 + amp * 0.85 * shape) * height);
        const x = i * (barW + gap);
        const y = (height - h) / 2;
        return (
          <rect
            key={i}
            x={x}
            y={y}
            rx={2}
            width={barW}
            height={h}
            fill={color}
          />
        );
      })}
    </svg>
  );
};

export default LiveWave;
